import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import '@mdi/font/css/materialdesignicons.css'
import "vuetify/dist/vuetify.min.css";
import "@/assets/scss/main.scss";
import "@/components/global";
import "@/utils/validators";
import "@/utils/filters";
import "@/router/guards";
import { status , lookupTypes , attachmentTypes,employeeStatus} from "./utils/common";
import { hasPermission } from "./utils/helpers";
import { installImageUploadGuard } from "./utils/imageUploadLimit";
import * as empManagementPermissions from "./permissions/employeeManagementPermissions";
import * as empOperationsPermissions from "./permissions/employeeOperationsPermissions";
import * as helpListPermissions from "./permissions/helpListPermissions";
import * as settingPermissions from "./permissions/settingPermissions";
import * as attendancePermissions from "./permissions/attendancePermissions";
import * as workSchedulePermissions from "./permissions/workSchedulePermissions";


installImageUploadGuard();

Vue.config.productionTip = false
Vue.prototype.$status = status;
Vue.prototype.$lookupTypes = lookupTypes;
Vue.prototype.$hasPermission = hasPermission;
Vue.prototype.$empManagementPermissions = empManagementPermissions;
Vue.prototype.$empOperationsPermissions = empOperationsPermissions;
Vue.prototype.$helpPermissions = helpListPermissions;
Vue.prototype.$settingPermissions = settingPermissions;
Vue.prototype.$attendancePermissions = attendancePermissions;
Vue.prototype.$workSchedulePermissions = workSchedulePermissions;
Vue.prototype.$attachmentTypes = attachmentTypes;
Vue.prototype.$employeeStatus = employeeStatus;


new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
